import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { SDS_STRIPE } from '../theme/solutionsDesignSystem';

// The 8-swatch rainbow stripe under the header / above the footer, from the
// Solutions page's design system — reused wherever a page adopts that look.
// `sticky` pins it directly beneath PbdqNav (which is itself position:sticky,
// top:0, height 70 — see pbdqShared.styles.js) so it stays visible while
// scrolling; only the instance right under the nav should pass this, not the
// one repeated above the footer.
const useStyles = makeStyles(() => ({
    stripe: {
        display: 'grid',
        gridTemplateColumns: 'repeat(8, minmax(0, 1fr))',
        height: 4,
    },
    stripeSticky: {
        position: 'sticky',
        top: 70,
        zIndex: 39,
    },
}));

const PbdqGradientStripe = ({ sticky }) => {
    const classes = useStyles();
    return (
        <div className={clsx(classes.stripe, sticky && classes.stripeSticky)} aria-hidden="true">
            {SDS_STRIPE.map((color) => <span key={color} style={{ background: color }} />)}
        </div>
    );
};

export default PbdqGradientStripe;
